import React, { PureComponent } from "react";
import Card from "./Card";
import PropTypes from "prop-types";
import toastr from "toastr";
import axios from "axios";

class PittconWidget extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            isLoading: true
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        const { filterGroups, sortOrders, pageSize, pageCount } = this.props;
        let query = "?";

        if (filterGroups && filterGroups instanceof Array)
            query += `filterGroups=${JSON.stringify(filterGroups)}&`;

        if (sortOrders && sortOrders instanceof Array)
            query += `sortOrders=${JSON.stringify(sortOrders)}&`;

        if (pageSize && typeof pageSize == "number" && pageCount && pageCount == "number")
            query += `pageSize=${pageSize * pageCount}&`;

        axios.get(`/api/events${query}`)
            .then(eventResults => this.setState({ data: eventResults.data.data }))
            .catch(() => toastr.error(`Error occurred grabbing event data!`))
            .finally(() => this.setState({ isLoading: false }));
    }

    render() {
        return (
            <div className="events-widget">
                {
                    this.props.title && <h2 className="title">{this.props.title}</h2>
                }
                <div className="EventGrid">
                    {this.state.data.map(({
                        url_key,
                        title,
                        event_image
                    }) => (
                        <Card
                            key={url_key}
                            title={title}
                            image={`${localStorage.restUrl}/pub/media/event/${event_image}`}
                            link={url_key}
                        />
                    ))}
                </div>
            </div>
        );
    }
}

PittconWidget.propTypes = {
    title: PropTypes.string,
    pageSize: PropTypes.number,
    pageCount: PropTypes.number,
    filterGroups: PropTypes.array,
    sortOrders: PropTypes.array
};

export default PittconWidget;